import { API_URL } from '../constants';

export async function fetchPlaylist(id) {
  return await fetch(`${API_URL}/playlist/${id}`)
    .then(res => res.json())
    .then(res => res.data)
    .catch(error => console.error(error.message));
}
